import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "rate-settings flex-center" }
const _hoisted_2 = { class: "rate-settings-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "title flex-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Get Paid for your Time")
], -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "rate-description description" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "subText" }, "Opt creates a standard link for you to share with the public through your email signature, website, social media and more. Don't worry, you can create unlimited unique links for specific meeting types or people.")
], -1 /* HOISTED */)
const _hoisted_5 = { class: "standard-meeting-rate-container flex-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "rate-title" }, "Your Standard Meeting", -1 /* HOISTED */)
const _hoisted_7 = { class: "payment-container" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "symbol" }, "$", -1 /* HOISTED */)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "editAmount" }, "Edit Standard Meeting Rate", -1 /* HOISTED */)
const _hoisted_10 = { class: "standard-meeting-time-container flex-center" }
const _hoisted_11 = { class: "time-subcontainer" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "editTime" }, "Edit Standard Meeting Duration", -1 /* HOISTED */)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "rate-description2 description" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "subText" }, "This will be the standard meeting rate when sending an Opt Offer, but it can still be changed during the creation process to better suit the meeting you're trying to hold.")
], -1 /* HOISTED */)
const _hoisted_14 = { class: "rate-settings-button btn-container" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            class: "paymentAmount",
            type: "number",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.updateRate) = $event)),
            min: "defaults.price.min",
            max: "defaults.price.max"
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, $setup.updateRate]
          ])
        ]),
        _hoisted_9
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("input", {
            class: "timeAmount",
            type: "number",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.updateDuration) = $event)),
            min: "defaults.length.min",
            max: "defaults.length.max"
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, $setup.updateDuration]
          ])
        ]),
        _hoisted_12
      ]),
      _hoisted_13
    ]),
    _createElementVNode("div", _hoisted_14, [
      ($setup.props.user.standardInviteLink)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "outline save-amount",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.updateStandardMeeting && $setup.updateStandardMeeting(...args))),
            disabled: $setup.loading
          }, "Save Amount", 8 /* PROPS */, _hoisted_15))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "outline save-amount",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.createStandardMeeting && $setup.createStandardMeeting(...args))),
            disabled: $setup.loading
          }, "Create", 8 /* PROPS */, _hoisted_16)),
      _createElementVNode("button", {
        class: "borderless back",
        onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.emit('close')))
      }, "Back")
    ])
  ]))
}